<template>
  <section>
    <VInput
      v-model="localStore.name"
      label="Наименование склада"
      layout="vertical"
      class="name"
    />

		<VTextarea
			v-model="localStore.address.stringRepresentation"
			label="Адрес склада"
			layout="vertical"
			required
			class="address"
		>
			<template #helper-text>
				Укажите фактический адрес склада, где можно забрать груз
			</template>
		</VTextarea>

		<VSelect
			:disabled="$core.currentPartner.isSeller"
      v-model="localStore.transportZone"
			layout="vertical"
			data-url="transportZones.getList"
			label="Транспортная зона"
			placeholder="Введите транспортную зону"
		/>

		<VTextarea
			ref="workingTimeInput"
			v-model="localStore.workingTime"
			label="График работы склада и контактные лица"
			layout="vertical"
			:min-height="140"
			required
		>
			<template #helper-text>
				Например пн-пт с 08:00 до 20:00
			</template>
		</VTextarea>

		<VTextarea
			ref="notesInput"
			v-model="localStore.notes"
			class="special-requirements"
			label="Особые требования на складе"
			layout="vertical"
		>
			<template #helper-text>
				Укажите, если есть особенные требования для въезда на территорию склада
			</template>
		</VTextarea>

		<VInput
			clearable
			label="Ссылка на карту с координатами склада"
			v-model="localStore.mapLink"
			layout="vertical"
			:max-length="85"
			:validate-method="validateMapLink"
		/>

		<VInputNumberRus
			ref="latitudeInput"
			label="Широта"
			v-model="localStore.coordinates.latitude"
			:precision="12"
			layout="vertical"
			:validate-method="validateLatitude"
			@input="onLatitudeInput"
		/>

		<VInputNumberRus
			ref="longitudeInput"
			label="Долгота"
			v-model="localStore.coordinates.longitude"
			:precision="12"
			layout="vertical"
			:validate-method="validateLongitude"
			@input="onLongitudeInput"
		/>
  </section>
</template>

<script>

import Store from '@/domains/Stores/Store.ts';
import Coordinates from "@/core/types/Coordinates";

export default defineComponent({
	name:   'StoreCreateSection',
	props:  {
		localStore: {
			type: [Object, Store],
			default: null,
		},
	},

	methods: {
		onLatitudeInput() {
			if (this.$refs.longitudeInput && typeof this.$refs.longitudeInput.validate === 'function') {
				this.$refs.longitudeInput.validate();
			}
		},

		onLongitudeInput() {
			if (this.$refs.latitudeInput && typeof this.$refs.latitudeInput.validate === 'function') {
				this.$refs.latitudeInput.validate();
			}
		},

		validateLongitude() {
			const latitude = this.localStore.coordinates.latitude;
			const longitude = this.localStore.coordinates.longitude;

			if ((longitude === null || longitude === undefined) && (latitude !== null && latitude !== undefined)) {
				return 'Долгота не может быть пустой. Долгота и широта должны быть заполнены вместе, либо вместе не заполнены';
			}

			if (longitude !== null && longitude !== undefined && latitude !== null && latitude !== undefined) {
				if (!Coordinates.inEurasia(latitude, longitude)) {
					return 'Координаты должны находиться в Евразии'
				}
			}

			return null;
		},

		validateLatitude() {
			const latitude = this.localStore.coordinates.latitude;
			const longitude = this.localStore.coordinates.longitude;

			if ((longitude !== null && longitude !== undefined) && (latitude === null || latitude === undefined)) {
				return 'Широта не может быть пустой. Долгота и широта должны быть заполнены вместе, либо вместе не заполнены';
			}

			if (longitude !== null && longitude !== undefined && latitude !== null && latitude !== undefined) {
				if (!Coordinates.inEurasia(latitude, longitude)) {
					return 'Координаты должны находиться в Евразии'
				}
			}

			return null;
		},

		validateMapLink(value) {
			if (typeof value === 'string' && value.length > 0) {
				const urlPattern = /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,}(\/\S*)?$/i;

				if (!urlPattern.test(value)) {
					return 'Введите ссылку на карту';
				}
			}

			return null;
		},
	}
});
</script>
